import { useState, useEffect } from 'react';
import { ProTable } from '@ant-design/pro-components';
import { Button, theme, Space, App } from 'antd';
import {
    useGetThirdPartyBillingDetailsQuery,
    useGetThirdPartyBillingInvoiceNamesQuery,
    useGetAllCustomerUidQuery,
    useDownloadThirdPartyBillingDetailsBySelectMutation,
    useDownloadThirdPartyBillingDetailsBySearchMutation,
} from '../../../features/api/apiSlice';
import { ThirdPartyBillingDetailsColumns } from './ThirdPartyBillingDetailsColumns';
import SurchargeModal from './SurchargeModal';
import { useSelector } from 'react-redux';
function ThirdPartyBillingDetailsPage() {
    const { token } = theme.useToken();
    const [searchData, setSearchData] = useState({});
    const { data, isLoading, isFetching, refetch } = useGetThirdPartyBillingDetailsQuery({...searchData});
    const { data: billingInvoiceNames } = useGetThirdPartyBillingInvoiceNamesQuery({ source_type: 1 }, { refetchOnMountOrArgChange: true });
    const { data: customerUidData } = useGetAllCustomerUidQuery();
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [surchargeModalContent, setSurchargeModalContent] = useState(null);
    const [surchargeModalOpen, setSurchargeModalOpen] = useState(false);
    const [currentModalTarget, setCurrentModalTarget] = useState(null);
    const { notification } = App.useApp();
    const currUser = useSelector((state) => state.auth.user);
    const [downloadBySelect, {
        isLoading: isDownloadBySelectLoading,
        isSuccess: isDownloadBySelectSuccess,
        isError: isDownloadBySelectError,
        error: downloadBySelectError,
    }] = useDownloadThirdPartyBillingDetailsBySelectMutation();
    const [downloadBySearch, {
        isLoading: isDownloadBySearchLoading,
        isSuccess: isDownloadBySearchSuccess,
        isError: isDownloadBySearchError,
        error: downloadBySearchError,
    }] = useDownloadThirdPartyBillingDetailsBySearchMutation();
    useEffect(() => {
        if (isDownloadBySearchSuccess) {
            notification.success({
                messgae: '成功',
                description: '下载成功, 请前往后台任务管理页面获取文件',
            })
        }
        if (isDownloadBySearchError) {
            notification.error({
                message: '失败',
                description: downloadBySearchError?.data?.message || '下载失败',
            })
        }
    }, [isDownloadBySearchSuccess, isDownloadBySearchError, downloadBySearchError?.data?.message]);
    console.log(searchData);
    useEffect(() => {
        if (isDownloadBySelectSuccess) {
            notification.success({
                messgae: '成功',
                description: '下载成功, 请前往后台任务管理页面获取文件',
            })
            setSelectedRowKeys([]);
        }
        if (isDownloadBySelectError) {
            notification.error({
                message: '失败',
                description: downloadBySelectError?.data?.message || '下载失败',
            })
        }
    }, [isDownloadBySelectSuccess, isDownloadBySelectError]);
    const columns = ThirdPartyBillingDetailsColumns(billingInvoiceNames, customerUidData, setSurchargeModalOpen, setSurchargeModalContent, setCurrentModalTarget);
    const rowSelection = {
        selectedRowKeys,
        onChange: (selectedRowKeys) => {
            setSelectedRowKeys(selectedRowKeys);
        },
    }
    const downloadBySelectButtonHandler = () => {
        const formData = new FormData();
        formData.append('detail_ids', selectedRowKeys);
        downloadBySelect(formData);
    }
    const downlaodBySearchButtonHandler = (searchConfig) => {
        searchConfig.form.validateFields().then((values) => {
            const request = {
                operation: "download",
                ...values,
            }
            downloadBySearch(request);
        })
    }
    return (
        <>
        <ProTable
            search={{
                span: { xs: 24, sm: 12, md: 8, lg: 8, xl: 8, xxl: 8 },
                labelWidth: 'auto',
                defaultCollapsed: false,
                style: {
                    maxWidth: 'none',
                    background: token.colorFillAlter,
                    borderRadius: token.borderRadiusLG,
                    padding: 24,
                },
                optionRender: (searchConfig, formProps, dom) => [
                    (currUser.button_permission?.includes('third_party_download_details') && <Button
                        key="downloadButton"
                        type="primary"
                        onClick={() => downlaodBySearchButtonHandler(searchConfig, formProps)}
                        loading={isDownloadBySearchLoading}
                    >
                        下载数据
                    </Button>),
                    ...dom,
                ],
            }}
            request={(params) => {
                setSearchData({ ...params });
            }}
            tableAlertOptionRender={() => {
                    return (
                        <Space size='small' >
                            {currUser.button_permission?.includes('third_party_download_details') && <Button type="link" loading={isDownloadBySelectLoading} onClick={() => downloadBySelectButtonHandler()}>下载数据</Button>}
                            <Button type="link" onClick={() => { setSelectedRowKeys([]) }}>取消选择</Button>
                        </Space>
                    )
                }}
            manualRequest={true}
            rowKey={record => record.id}
            dataSource={data?.results}
            loading={isLoading || isFetching}
            columns={columns}
            rowSelection={rowSelection}
            pagination={{
                defaultPageSize: 10,
                showSizeChanger: true,
                pageSizeOptions: ['10', '20', '50', '100'],
                total: data?.count,
            }}
            scroll={{ x: 'max-content' }}
            options={{
                reload: () => refetch(),
            }}
        />
        <SurchargeModal
            open={surchargeModalOpen}
            setOpen={setSurchargeModalOpen}
            data={surchargeModalContent}
            target={currentModalTarget}
            />
        </>
    )
}

export default ThirdPartyBillingDetailsPage;